module.exports = __webpack_public_path__ + "static/media/filtroPurpura.6ad94184.pdf";